import CommonApp from '../../app.js';
import modelPopup from './model-popup.html';

CommonApp.module.directive('nsCustomModalComponent', function() {
    return {
        template: modelPopup,
        restrict: 'E',
        scope: {
            isModalCall: '@',
            srcUrl: '@',
            callbackOnSuccess: '@',
            modalHeading: '@',
            back: '@',
            goBack: '@'
        },
        controller: customModalController,
        controllerAs: 'ctrl',
        bindToController: true
    };
});

var customModalController = function($scope, $uibModal, $sce) {
    this.$uibModal = $uibModal;
    var self = this;
    self.modalPopupInstance = function(controller, windowClass, $uibModal) {
        var modelPopuptemplate = require('./model-popup.html');
        var modalInstance = $uibModal.open({
            animation: true,
            backdrop: 'static',
            keyboard: false,
            template: modelPopuptemplate,
            controller: ['$uibModalInstance', function($uibModalInstance) {
                var modalSelf = this;
                modalSelf.model = {};

                modalSelf.model.addressList = self.addressList;

                modalSelf.addressData = self.addressData;

                modalSelf.srcUrl = $sce.trustAsResourceUrl(self.srcUrl);
                
                modalSelf.back = self.back;
                
                modalSelf.goBack = self.goBack;

                modalSelf.modalHeading = self.modalHeading;

                modalSelf.trustedURL = $sce.trustAsResourceUrl(self.srcUrl);

                modalSelf.ok = function() {
                    $uibModalInstance.close();
                };

                modalSelf.trustUrl = function(url) {
                    return $sce.trustAsResourceUrl(url);
                };

                modalSelf.cancel = function() {
                    $uibModalInstance.dismiss();
                };

                modalSelf.goBackAndEdit = function() {
                    modalSelf.cancel();
                    var resetBooleanVariable = '$scope.$parent.' + self.callbackOnSuccess + '()';
                    eval(resetBooleanVariable);
                };
            }],
            controllerAs: 'ctrl',
            windowClass: windowClass,
            size: 'md'
        });
    };

    self.trustUrl = function(url) {
        return $sce.trustAsResourceUrl(url);
    };

    this.$onInit = function() {
        if (self.isModalCall) {
            self.modalPopupInstance(this.customModalController, 'custom-modal-popup', this.$uibModal);
        }
    };
};

customModalController.$inject = ['$scope', '$uibModal', '$sce'];





//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/directives/model-popup/model-popup.js
// module id = 269
// module chunks = 0